import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

import * as stripe from '@stripe/stripe-js';

import { NzFormControlComponent } from 'ng-zorro-antd/form';

import { PaymentMethodsStripeService } from '../../services/payment-methods-stripe.service';

@Component({
  standalone: false,
  selector: 'adspt-stripe-input',
  templateUrl: './stripe-input.component.html',
  styleUrls: ['./stripe-input.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StripeInputComponent implements OnInit, OnDestroy {
  @Input()
  name: stripe.StripeElementType;

  @ViewChild('input', { static: true, read: ElementRef })
  input: ElementRef<HTMLElement>;

  @ViewChild('formItem', { static: true, read: ElementRef })
  formItem: ElementRef<HTMLElement>;

  @ViewChild(NzFormControlComponent, { static: true })
  formControl: NzFormControlComponent;

  constructor(private pms: PaymentMethodsStripeService) {}

  ngOnInit(): void {
    this.pms.createElement(this.name, this.input, this.formItem, this.formControl);
  }

  ngOnDestroy(): void {
    this.pms.destroyElement(this.name);
  }
}
